<template lang="pug">
.row
  .col-md-2

  .col-md-8
    h1 New Section Status

    Form(:squeue="squeueStore.squeue")

  .col-md-2
</template>

<script>
  import { mapStores } from 'pinia'
  import { useSqueueStore } from '@/stores/squeue'

  import Form from '../shared/form.vue'

  export default {
    components: {
      Form
    },

    computed: {
      ...mapStores(useSqueueStore)
    },

    mounted() {
      this.squeueStore.$reset()
    }
  }
</script>
